import styled from "@emotion/styled";

export function Empty() {
  return <Container>this is empty</Container>;
}

const Container = styled.div``;
